import { Button, Table, Icon } from '@salecycle/ui-component-library';
import { FC } from 'react';
import { Column } from 'react-table';
import IP from 'entities/ip';

export interface IProps {
  ips: { [id: string]: IP };
  globalIps: IP[];
  delete: (id: string) => void;
}

const IPWhitelistTable: FC<IProps> = props => {
  const ips = [
    ...props.globalIps.map(globalIp => ({ ...globalIp, id: null, type: 'global' })),
    ...Object.keys(props.ips).map(id => ({ ...props.ips[id], id, type: 'individual' })),
  ];

  const tableColumns: Column[] = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'IP Address',
      accessor: 'ip',
    },
    {
      accessor: 'type',
      // eslint-disable-next-line react/display-name
      Cell: tableProps =>
        tableProps.row.type === 'individual' && (
          <Button variation="secondary" onClick={() => props.delete(tableProps.original.id)}>
            <Icon icon="trash" />
          </Button>
        ),
      width: 125,
    },
  ];
  return (
    <div data-testid="IPWhitelistTable">
      <Table data={ips} columns={tableColumns} />
    </div>
  );
};

export default IPWhitelistTable;
